<template>
  <section :style="[isIntro ? selectedStyle : noTest]">
    <section class="px-5">
      <!-- QUESTION -->
      <blockquote style="text-align: center;" :class="{'vert' : isIntro}"  class="blockquote pa-0 pb-2 ma-0" >
        <span :class="{'bebas-2' : isIntro}" :style="[isIntro ? headerStyle : noTest]">{{question.text}}</span>
        <br v-if="showMirrorText">
        <span class="bebas-1" v-show="showMirrorText">(Keep a mirror handy.)</span>
      </blockquote>
      

      <!-- ANSWERS -->
      <input v-if="question.type == 'text'" type="text" class="mb-4" v-model="question.answer" style=" padding: 15px; width: 100%; font-size: 18px;" placeholder="Name"/>
      <!-- <div v-if="question.type == 'text'">
        <v-text-field
          single-line
          outline
          placeholder="Name"
          :color="sectionColor"
          v-model="question.answer"
          required
          class="square"
          ></v-text-field>
      </div> -->
      
      <!-- <input v-if="question.type == 'number'" type="text" class="mb-4" v-model="question.answer" style=" padding: 15px; width: 100%; font-size: 18px;" placeholder="Zip Code"/> -->
      <div v-if="question.type == 'number'">
        <div 
          :style="unselectedStyle" 
          style="overflow: hidden" 
          :class="hoverButton"
          class="customButton" 
          @click="locate()">
          Locate Me
        </div>
      </div>



      <div v-if="question.type == 'number'" style="visibility:hidden" >
        <v-text-field
          single-line
          outline
          :color="sectionColor"
          mask="#####"
          v-model="question.answer"
          required
          class="square"
          ></v-text-field>
      </div>
    
      <div v-if="question.type == 'singleSelect'">
        <v-container fluid class="pa-0">
          <v-layout row wrap >
            <v-flex xs12 sm6 v-for="o in question.options" :key="o.text">
              <div 
                :style="[question.answer && o.text===question.answer.text  ? selectedStyle : unselectedStyle]" 
                style="overflow: hidden" 
                :class="hoverButton"
                class="customButton" 
                
                @click="answerQuestion(o)">
                {{o.text}}
              </div>



            </v-flex>
          </v-layout>
        </v-container>
      </div>

      <div v-if="question.type == 'multiSelect'">
        <v-container fluid>
          <span v-for="o in question.options" :key="o.text">
            <v-checkbox
              multiple
              :color="sectionColor"
              v-model="question.answer"
              :label="o.text"
              :value="o"
              ></v-checkbox>
          </span>
        </v-container>
      </div>
    </section>
  </section>
</template>

<script>
//import { POINT_CONVERSION_COMPRESSED } from 'constants';
export default {
  name: 'questionCard',
  props: {
    question: Object,
    answer: Function
  },
  components: {},
  computed: {
    showMirrorText(){
      if (this.question.questionId == 16){
        return true;
      }
      else{
        return false;
      }

    },
    containerStyle(){
      return{
        position: 'absoltue',
        top: '50%',
      };
    },
    isIntro(){
      if (this.question.type == 'intro'){
        return true;
      }
      else{
        return false;
      }
    },
    noTest(){
      return {};
    },
    headerStyle() {
      return {
        color: 'white'
      };
    },
    unselectedStyle() {
      return {
        borderColor: this.sectionColor,
        color: '#616161'
      };
    },
    selectedStyle() {
      return {
        borderColor: this.sectionColor,
        backgroundColor: this.sectionColor,
        color: 'white'
      };
    },
    sectionColor: function() {
      if (this.question.section == 'SECTION A: INTRO') {
        return '#9069AD';
      }
      if (this.question.section == 'SECTION B: BASICS') {
        return '#C560A4';
      }
      if (this.question.section == 'SECTION C: HABITS') {
        return '#F0887F';
      }
      if (this.question.section == 'SECTION D: SKIN HEALTH') {
        return '#3DABC5';
      }
      if (this.question.section == 'SECTION E: RESULTS') {
        return '#5872B7';
      }
      else{
        return '#9069AD';
      }
    },
    borderColor: function() {
      return '{\'color\': #9069AD}';
    },
    hoverButton: function() {
      if (this.question.section == 'SECTION B: BASICS') {
        return 'basics';
      }
      if (this.question.section == 'SECTION C: HABITS') {
        return 'habits';
      }
      else{
        return 'testing';
      }
    },
    
  },
  data() {
    return { text: '', selectedOption: '', selected: [], hover: false };
  },
  created() {},
  mounted() {
    // console.log(this.question);
  },
  methods: {
    expandArray: function(o) {
      if (!Array.isArray(this.question.answer)) {
        this.question.answer = [];
        this.question.answer.push(o);
      }
    },
    answerQuestion: function (ans) {
      this.question.answer = ans;
      this.answer(true, false);
    },
    locate: function (){
      if (window.navigator && window.navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.onGeolocateSuccess, this.onGeolocateError);
      } else{
        ans = ('failed window.navigator && window.navigator.geolocation');
        this.answerQuestion(ans);
      }
    },
    onGeolocateSuccess: function (coordinates){
      const { latitude, longitude } = coordinates.coords;
      let ans = latitude + ', ' + longitude;
      // console.log(ans);
      this.answerQuestion(ans);
    },
    onGeolocateError: function (error){      
      let ans = '';
      if (error.code === 1) {
        ans = ('User Denied Location');
        this.answerQuestion(ans);
      } else if (error.code === 2) {
        ans = ('Position Unavailable');
        this.answerQuestion(ans);
      } else if (error.code === 3) {
        ans = ('Position Unavailable');
        this.answerQuestion(ans);
      }
      else {
        ans = ('Unknown Error');
        this.answerQuestion(ans);
      }
    }
  }
};
</script>

<style scoped>
.customButton{
  text-align: center;
  border: 1px solid;
  margin: 3px;
  padding: 4px;
  cursor: pointer;
  height: 52px;
  line-height: 44px;
}
.vert{
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 300px;
}
input[type=text], textarea {
  -webkit-transition: all 0.30s ease-in-out;
  -moz-transition: all 0.30s ease-in-out;
  -ms-transition: all 0.30s ease-in-out;
  -o-transition: all 0.30s ease-in-out;
  outline: none;
  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;
  border: 1px solid #DDDDDD;
}
 
input[type=text]:focus, textarea:focus {
  /* box-shadow: 0 0 5px rgba(81, 203, 238, 1); */
  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;
  border: 1px solid rgb(197, 96, 164);
}

.square{
  border-radius: 0px !important;
}

.basics:hover {
  background-color: #c560a415;
}

.habits:hover {
  background-color: #f0887f15;
}

.testing:hover {
  background-color: #3dabc515;
}

@media (max-width: 600px) {
  .customButton{
    margin: 0px;
    padding: 0px;
    cursor: pointer;
    height: 42px;
  }
  .basics:hover {
    background-color: white;
  }

  .habits:hover {
    background-color: white;
  }

  .testing:hover {
    background-color: white;
  }

}
</style>
